__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "seller-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@kar-dmp/omp-shared-library", "7.37.0", () => (Promise.all([__webpack_require__.e(6783), __webpack_require__.e(3727), __webpack_require__.e(7799), __webpack_require__.e(9823), __webpack_require__.e(549), __webpack_require__.e(7916), __webpack_require__.e(9974)]).then(() => (() => (__webpack_require__(3727))))));
			register("@kar-dmp/pattern-library", "6.19.0", () => (Promise.all([__webpack_require__.e(4014), __webpack_require__.e(4882), __webpack_require__.e(7926), __webpack_require__.e(6783), __webpack_require__.e(4470)]).then(() => (() => (__webpack_require__(16880))))));
			register("@kar-dmp/pattern-library", "6.25.1", () => (Promise.all([__webpack_require__.e(3573), __webpack_require__.e(3428)]).then(() => (() => (__webpack_require__(33573))))));
			register("@module-federation/utilities", "3.1.6", () => (__webpack_require__.e(6636).then(() => (() => (__webpack_require__(16636))))));
			register("@ramonak/react-progress-bar", "5.2.0", () => (Promise.all([__webpack_require__.e(7799), __webpack_require__.e(8093)]).then(() => (() => (__webpack_require__(78093))))));
			register("@reduxjs/toolkit", "1.9.6", () => (__webpack_require__.e(5679).then(() => (() => (__webpack_require__(15679))))));
			register("@tanstack/react-query", "5.40.1", () => (Promise.all([__webpack_require__.e(5084), __webpack_require__.e(7799), __webpack_require__.e(4848)]).then(() => (() => (__webpack_require__(85084))))));
			register("@tanstack/react-table", "8.16.0", () => (Promise.all([__webpack_require__.e(9233), __webpack_require__.e(7799)]).then(() => (() => (__webpack_require__(59233))))));
			register("@tanstack/react-virtual", "3.5.0", () => (Promise.all([__webpack_require__.e(2181), __webpack_require__.e(7799), __webpack_require__.e(9823)]).then(() => (() => (__webpack_require__(72181))))));
			register("axios", "1.7.7", () => (__webpack_require__.e(4447).then(() => (() => (__webpack_require__(84447))))));
			register("date-fns", "3.6.0", () => (__webpack_require__.e(9437).then(() => (() => (__webpack_require__(89437))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(7799)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-intl", "6.4.7", () => (Promise.all([__webpack_require__.e(8530), __webpack_require__.e(7799)]).then(() => (() => (__webpack_require__(88530))))));
			register("react-redux", "8.1.2", () => (Promise.all([__webpack_require__.e(134), __webpack_require__.e(7799), __webpack_require__.e(9823)]).then(() => (() => (__webpack_require__(60134))))));
			register("react-router-dom", "6.16.0", () => (Promise.all([__webpack_require__.e(2648), __webpack_require__.e(7799)]).then(() => (() => (__webpack_require__(92648))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(2568), __webpack_require__.e(7799)]).then(() => (() => (__webpack_require__(92568))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};